import { render, staticRenderFns } from "./risk_blogger_label_list.vue?vue&type=template&id=ccc8bdd0&scoped=true"
import script from "./risk_blogger_label_list.vue?vue&type=script&lang=ts"
export * from "./risk_blogger_label_list.vue?vue&type=script&lang=ts"
import style0 from "./risk_blogger_label_list.vue?vue&type=style&index=0&id=ccc8bdd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc8bdd0",
  null
  
)

export default component.exports